export default "__VITE_ASSET__3855e30b__"